export default __webpack_public_path__ + "static/media/157.f3707901.png";